// Define this here to allow it to be used both in this theme and individual components
import { spacing } from './constants';

// TODO: Find a better place
export const glassBackdrop = {
    // borderRadius: 2.5 * spacing,
    // border: `1px solid ${alpha(grey[500], 0.25)}`,
    // background: alpha(grey[800], 0.75),
    // backdropFilter: 'blur(12px)',
    // boxShadow: `
    //     inset 0 0 40px ${alpha(grey[800], 0.65)},
    //     0px 1px 8px 0px rgba(0, 0, 0, ${0.2 * shadowFactor}),
    //     0px 3px 4px 0px rgba(0, 0, 0, ${0.1 * shadowFactor}),
    //     0px 3px 3px -2px rgba(0, 0, 0, ${0.1 * shadowFactor})`,

    background: 'none',
    borderRadius: 2.5 * spacing,
    backdropFilter: 'blur(32px) brightness(0.65) contrast(0.65) saturate(3)',
};

export const lightGlassBackdrop = {
    // borderRadius: 2.5 * spacing,
    // border: `1px solid ${alpha(grey[0], 0.2)}`,
    // background: alpha(grey[800], 0.4),
    // backdropFilter: 'blur(12px)',
    // boxShadow: `
    //     inset 0 0 40px ${alpha(grey[800], 0.25)},
    //     0px 1px 8px 0px rgba(0, 0, 0, ${0.2 * shadowFactor}),
    //     0px 3px 4px 0px rgba(0, 0, 0, ${0.1 * shadowFactor}),
    //     0px 3px 3px -2px rgba(0, 0, 0, ${0.1 * shadowFactor})`,

    background: 'none',
    borderRadius: 2.5 * spacing,
    backdropFilter: 'blur(32px) brightness(0.65) contrast(0.65) saturate(3)',
};

// Define this here to allow it to be used both in this theme and individual components
// TODO: Find a better place
export const glassBackdropSheet = {
    //     borderRadius: `${2.5 * spacing}px !important`,
    //     border: `1px solid ${alpha(grey[500], 0.25)} !important`,
    //     background: `${alpha(grey[800], 0.6)} !important`,
    //     backdropFilter: 'blur(12px) !important',
    //     boxShadow: `
    //         inset 0 0 40px ${alpha(grey[800], 0.65)},
    //         0px 1px 8px 0px rgba(0, 0, 0, ${0.2 * shadowFactor}),
    //         0px 3px 4px 0px rgba(0, 0, 0, ${0.1 * shadowFactor}),
    //         0px 3px 3px -2px rgba(0, 0, 0, ${0.1 * shadowFactor})
    //         !important`,

    background: 'none',
    borderRadius: 2.5 * spacing,
    backdropFilter: 'blur(32px) brightness(0.65) contrast(0.65) saturate(3)',
};
